import { Component, OnInit, OnDestroy, NgZone, ChangeDetectorRef } from '@angular/core';
import { MainService } from './services/main-service.service';
import { ProposalService } from './services/proposal/proposal.service';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonModule } from '@angular/common';

declare global {
  interface Window {
    gtranslateSettings: {
      default_language: string;
      detect_browser_language: boolean;
      languages: string[];
      wrapper_selector: string;
    };
  }
}
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit, OnDestroy {
  loader: boolean;
  errorMessage: any;
  hide_header_footer = 0;
  is_iframe;
  mobile_designs = 0;
  planInfo = {};
  contribute_card_panel = false;
  card_panel = false;
  location: any;
  routeAddBank = false;
  // Maintenance window in IST (12:00 PM–1:00 PM, 16 Jul 2026 => 06:30–07:30 UTC).
  // Labels are derived from these instants and rendered in the viewer's local zone.
  serverMaintenance = {
    show: false,
    dismissed: false,
    start: Date.UTC(2026, 6, 20, 6, 30, 0), // 20 Jul 2026, 12:00 PM IST
    end: Date.UTC(2026, 6, 20, 7, 30, 0), // 20 Jul 2026, 1:00 PM IST
    tzLabel: '',
    dateLabel: '',
    startLabel: '',
    endLabel: '',
    windowLabel: '',
  };
  private maintenanceTimer: any;
  private static readonly MAX_TIMEOUT = 2147483647; // setTimeout 32-bit ceiling (~24.8 days)
  // tslint:disable-next-line:max-line-length
  constructor(public mainService: MainService, public proposal: ProposalService, private zone: NgZone, public cd: ChangeDetectorRef, private titleService: Title, private _activate: ActivatedRoute, private _router: Router) {
    this.mainService.setLoader(true);
    this.cd.markForCheck();
  }

  ngOnInit() {
    this.initGtranslate();
    this.startLanguagePolling()
    this.evaluateServerMaintenance();
    if (window.location.href.includes('request/bank?patient_id=')) {
      this.routeAddBank = true;
    } else {
      this.routeAddBank = false;
    }
    this.is_iframe = window.location != window.parent.location;
    // tslint:disable-next-line:max-line-length
    this.mobile_designs = (window.location.pathname.includes('/pay-now') || window.location.pathname.includes('/plans') || window.location.pathname.includes('/payment-details') || window.location.pathname.includes('/request/pay-now') || window.location.pathname.includes('/request/plans') || window.location.pathname.includes('/request/payment-details')) && window.screen.width < 768 ? 1 : 0;
    // tslint:disable-next-line:max-line-length
    if (window.location.pathname == '/finance-panel' || window.location.pathname == '/tila' || window.location.pathname == '/request/finance-panel' || window.location.pathname == '/request/tila' || window.location.pathname == '/meet-link') {
      this.hide_header_footer = 1;
      this.titleService.setTitle(`Customer Proposal`);
      this.contribute_card_panel = false;
    } else if (window.location.pathname.includes('/contribute') || window.location.pathname.includes('/add-card')) {
      this.contribute_card_panel = true;
      this.hide_header_footer = 1;
      if (window.location.pathname.includes('/add-card')) {
        this.card_panel = true;
      }
    } else {
      this.titleService.setTitle(`Credee - Customer Proposal`);
      this.contribute_card_panel = false;
    }
    this.mainService.getLoader().subscribe((data: any) => {
      this.zone.run(() => {
        this.loader = data;
        //console.log(this.loader);
        this.cd.detectChanges();
      });
    });

    this.mainService.init().subscribe((data: any) => {
      // this.settingsData = data;
      // this.mainService.setLoader(false);
      //console.log('App Component Started');
    });
    this.proposal.getPaymentData().subscribe((data: any) => {
      this.planInfo = data;
    })
    this.proposal.getData().subscribe((data: any) => {
      if (data.split_request_data) {
        this.planInfo = data.split_request_data[0];
      } else if (data && data.result && data.result.patient_email) {
        this.planInfo = data.result;
      }
    })
  }

  setAppFavicon(id: string, basepath: string, icon: string) {
    // $('#'+id).attr('href', basepath+'/'+ icon);
  }

  // Builds the banner copy from start/end, rendered in the viewer's local zone.
  buildMaintenanceCopy() {
    const m = this.serverMaintenance;
    const startDate = new Date(m.start);
    const endDate = new Date(m.end);
    const dateFmt = new Intl.DateTimeFormat(undefined, { month: 'long', day: 'numeric' });
    const timeFmt = new Intl.DateTimeFormat(undefined, { hour: 'numeric', minute: '2-digit', hour12: true });

    m.dateLabel = dateFmt.format(startDate);
    m.startLabel = timeFmt.format(startDate);
    m.endLabel = timeFmt.format(endDate);
    m.tzLabel = this.getLocalTimeZoneLabel(startDate);

    const endDateLabel = dateFmt.format(endDate);
    m.windowLabel = m.dateLabel === endDateLabel
      ? `${m.dateLabel}, ${m.startLabel}–${m.endLabel} ${m.tzLabel}`
      : `${m.dateLabel}, ${m.startLabel} – ${endDateLabel}, ${m.endLabel} ${m.tzLabel}`;
  }

  // Derives a short zone abbreviation from the long name's initials
  // ("India Standard Time" -> "IST"), falling back to a GMT offset for
  // unnamed zones where the short name is already an offset (e.g. GMT+5:45).
  getLocalTimeZoneLabel(date: Date): string {
    try {
      const parts = new Intl.DateTimeFormat('en-US', { timeZoneName: 'long' }).formatToParts(date);
      const name = parts.find(p => p.type === 'timeZoneName')?.value;
      if (name && !/gmt|utc|[0-9]/i.test(name)) {
        const abbr = name.split(/\s+/).map(w => w.charAt(0)).join('').toUpperCase();
        if (abbr.length >= 2) { return abbr; }
      }
    } catch { /* fall through to offset */ }

    const offsetMin = -date.getTimezoneOffset();
    const sign = offsetMin >= 0 ? '+' : '-';
    const abs = Math.abs(offsetMin);
    const mm = abs % 60;
    return `GMT${sign}${Math.floor(abs / 60)}${mm ? ':' + String(mm).padStart(2, '0') : ''}`;
  }

  // Shows the notice until the window ends, then auto-hides it.
  evaluateServerMaintenance() {
    this.buildMaintenanceCopy();
    const { end } = this.serverMaintenance;
    const msUntilEnd = end - Date.now();
    if (msUntilEnd <= 0) { return; }

    this.serverMaintenance.show = true;
    if (msUntilEnd <= AppComponent.MAX_TIMEOUT) {
      this.maintenanceTimer = setTimeout(() => {
        this.zone.run(() => {
          this.serverMaintenance.show = false;
          this.cd.detectChanges();
        });
      }, msUntilEnd);
    }
  }

  isMaintenanceActive(): boolean {
    const now = Date.now();
    return now >= this.serverMaintenance.start && now < this.serverMaintenance.end;
  }

  dismissMaintenance() {
    this.serverMaintenance.dismissed = true;
  }

  ngOnDestroy() {
    clearTimeout(this.maintenanceTimer);
  }

  onActivate(event) {
    let scrollToTop = window.setInterval(() => {
      let pos = window.pageYOffset;
      if (pos > 0) {
        window.scrollTo(0, pos - 20);
      } else {
        window.clearInterval(scrollToTop);
      }
    }, 16);
  }

  checkLocation(location) {
    let useloc = false;
    if (window.location.pathname.includes(location)) {
      useloc = true;
    }
    let body;
    body = window.document.body;
    if (body) {
      body.classList.add('bg_gray')
    }
    return useloc;
  }

  initGtranslate() {
    const gTranslateSettings = {
      default_language: 'en',
      native_language_names: true,
      detect_browser_language: true,
      languages: ['en', 'de', 'it', 'es', 'fr', 'pl', 'ja'],
      wrapper_selector: '.gtranslate_wrapper',
      alt_flags: { en: 'usa' }
      // url_structure: 'sub_directory'
    };
    const script = document.createElement('script');
    script.src = 'https://cdn.gtranslate.net/widgets/latest/float.js';
    script.defer = true;
    document.body.appendChild(script);
    window.gtranslateSettings = gTranslateSettings;
  }

  startLanguagePolling(id=0) {
    setTimeout(() => {
      let Element: any = document.getElementsByClassName("gt-current")[0]
      let currentLang = Element && Element.getAttribute("data-gt-lang")
      this.proposal.currentLang.next(currentLang ? currentLang : "en")
      const is_iframe = (window.location != window.parent.location) ? true : false;
      if (currentLang === 'en' && id==1 && is_iframe) {
        window.location.reload();
        id=0
      }
    }, 1000);
  }
}